'use strict';
// Batch-only AI-request message construction. CommonJS so Jest can require it and
// so the batch record builder can produce a `messages` array byte-identical to what
// the realtime callAI POSTs to /ai. This DUPLICATES the realtime callAI's userContent
// logic on purpose (the realtime callAI is left untouched per the "byte-untouched
// realtime" decision). A source-guard test (Task 4b) asserts the realtime callAI
// still builds this exact shape, so the copies cannot silently diverge. No React/fetch.

function buildUserMessages(prompt, cachedPrefix) {
  if (cachedPrefix) {
    return [{ role: 'user', content: [
      { type: 'text', text: cachedPrefix, cache_control: { type: 'ephemeral' } },
      { type: 'text', text: prompt },
    ] }];
  }
  return [{ role: 'user', content: prompt }];
}

// v2 source: normalizeAiModel (ccm-compliance.js:3409-3416)
function normalizeAiModel(model) {
  const raw = String(model || '').toLowerCase();
  if (raw === 'bedrock-opus' || raw === 'bedrock-sonnet' || raw === 'bedrock-haiku') return raw;
  if (raw.indexOf('opus') !== -1) return 'bedrock-opus';
  if (raw.indexOf('sonnet') !== -1) return 'bedrock-sonnet';
  if (raw.indexOf('haiku') !== -1 || raw.indexOf('mini') !== -1 || raw.indexOf('nano') !== -1) return 'bedrock-haiku';
  return 'bedrock-sonnet';
}

module.exports = { buildUserMessages, normalizeAiModel };
